const commonConfig = {
    firebase:{
     api_key: process.env.REACT_APP_FIREBASE_API_KEY,
     auth_domain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
     project_id: process.env.REACT_APP_FIREBASE_PROJECT_ID,
     storage_bucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
     sender_id: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
     app_id:process.env. REACT_APP_FIREBASE_APP_ID
    },
    ai:{
        base_url: process.env.REACT_APP_API_AI_URL
    },
    app_url: process.env.REACT_APP_URL,
    hosting_url: process.env.REACT_APP_HOSTING_URL,
    cloud_function: {
        base_url: process.env.REACT_APP_CLOUD_FUNCTION_API
    },
    users:{
        admin: 20,
        staff: 5
    }
 };
 
 
 // Generate final config by merging the common config with any environment-specific overrides
 const getConfig = () => {
     return {
         ...commonConfig
     };
 };
 
 const config = getConfig();
 
 export default config;
 